// extracted by mini-css-extract-plugin
module.exports = {"button":"borderButton_button__2qqMu"};